import { Component, OnInit, inject } from '@angular/core';
import { ROUTES } from './sidebar-routes.config';
import { RouteInfo } from './sidebar.metadata';
import { Router, ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass } from '@angular/common';
import { CheckRoleDirective } from '../../directives/checkrole-directive';
import { NewsService } from 'app/services/news.service';

declare var $: any;
@Component({
    // moduleId: module.id,
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    imports: [RouterLink, CheckRoleDirective, NgClass, RouterLinkActive]
})

export class SidebarComponent implements OnInit {
    private router = inject(Router);
    private route = inject(ActivatedRoute);
    private newsService = inject(NewsService);

    public menuItems: any[];
    softwareVersion = '';

    ngOnInit() {
        $.getScript('./assets/js/app-sidebar.js');
        this.menuItems = ROUTES.filter(menuItem => menuItem);
        this.newsService.getSoftwareVersion().subscribe(x => this.softwareVersion = x);
    }

}
